import React, { useContext } from "react";
import styled from "styled-components";
import { ThemeContext } from "../../../../core/providers/ThemeContext";
import { Hidden, useTheme } from "@material-ui/core";
import useWizard from "../../../../core/hooks/useWizard";
import StatusWizardIndicator from "./StatusWizardIndicator";
import { includes } from "lodash";
import {
  BORDER_RADIUS_BLOCKS,
  FORM_STYLES_V2,
} from "../../customSimpleFields/styles/SharedStyles";
import {
  FORM_BACKGROUND,
  MAIN_COLOR,
  TEXT_PRIMARY,
  BLOCKS_HEADER_BG,
} from "../../../../shared/theme/dark";

import { BLOCKS_HEADER_BG as BLOCKS_HEADER_BG_LIGHT } from "../../../../shared/theme/light";
import ConstructorBlockDialog from "../../constructor/ConstructorBlockDialog";

const StyledBlock = styled.div`
  height: inherit;
  width: inherit;
  overflow-y: auto;
  transform: ${({ hasLegend }) =>
    hasLegend ? "translateY(0px)" : "translateY(8px)"};

  pointer-events: ${({ blockShouldBeDisabled }) =>
    blockShouldBeDisabled ? "none" : "auto"};

  cursor: ${({ blockShouldBeDisabled }) =>
    blockShouldBeDisabled ? "not-allowed" : "auto"};

  .rjsf {
    height: inherit;
  }

  .rjsf > div > fieldset {
    overflow-y: auto;
  }

  /* TO HIDE RJSF OWN LABEL, AND ONLY SHOW OUR CUSTOM LABELS*/
  .control-label {
    display: none;
  }

  .form-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 2;
    width: auto;
  }

  .form-control {
    border-width: 0.5px;
    border-style: solid;
    border-color: ${({ pre, themeType, defValues }) =>
      pre?.borderC && pre?.borderC[themeType]
        ? pre?.borderC[themeType]
        : defValues?.mainColor};
    border-radius: 5px;
    font-family: THEME_FONT_ID, THEME_FONT_FAMILY;
  }

  .form-control:active {
    border: 1px solid
      ${({ defValues }) =>
        defValues?.mainColor ? defValues.mainColor : "#026dad"};
  }

  .field-object {
    height: inherit;
  }

  .field-boolean {
    display: flex;
    width: auto;
    align-items: center;
    justify-content: flex-end;
  }

  fieldset {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: "space-between";
    background-color: ${({ pre, themeType, defValues }) =>
      pre?.bgC && pre?.bgC[themeType]
        ? pre?.bgC[themeType]
        : defValues?.blockBackground};
    border-width: ${({ pre, defValues, blockShouldBeDisabled }) =>
      blockShouldBeDisabled === true
        ? "1px"
        : pre && pre.borderW
        ? pre.borderW
        : defValues?.borderBlockWidth || "1px"};
    border-style: ${({ pre }) => (pre && pre.borderS ? pre.borderS : "solid")};
    border-color: ${({ pre, themeType, defValues, blockShouldBeDisabled }) =>
      blockShouldBeDisabled === true
        ? null
        : pre && pre?.borderC && pre?.borderC[themeType]
        ? pre?.borderC[themeType]
        : defValues?.borderBlockColor};
    border-radius: ${({ pre }) => (pre && pre.borderR ? pre.borderR : "10px")};
    width: -webkit-fill-available;
    height: -webkit-fill-available;
    pointer-events: ${({ blockShouldBeDisabled }) =>
      blockShouldBeDisabled ? "none" : "auto"};

    padding-block-start: ${({ blockShouldBeFocused }) =>
      blockShouldBeFocused ? "0.2em" : "inherit"};

    padding-bottom: ${({ blockShouldBeFocused }) =>
      blockShouldBeFocused ? "2px" : "inherit"};
  }

  fieldset fieldset {
    border: none;
    margin: 0;
    padding: 0;
    height: min-content;
    background: inherit;
    pointer-events: ${({ blockShouldBeDisabled }) =>
      blockShouldBeDisabled ? "none" : "auto"};
  }

  /* TO QUIT INNER LEGENDS */
  fieldset fieldset legend {
    display: none;
  }

  fieldset .field-object {
    height: min-content;
  }

  legend {
    font-size: ${({ pre }) => (pre && pre.titleW ? pre.titleW : "1rem")};
    font-weight: ${({ pre }) =>
      pre && pre.titleWeight ? pre.titleWeight : "500"};
    line-height: 1;
    letter-spacing: 0.0075em;
    color: ${({ pre, themeType, defValues, blockShouldBeDisabled }) =>
      blockShouldBeDisabled === true
        ? "grey"
        : pre?.borderC && pre?.borderC[themeType]
        ? pre?.borderC[themeType]
        : defValues?.mainColor};
  }

  input:disabled {
    background-color: inherit;
  }

  .switch-wrapper {
    position: relative;
  }

  .switch-wrapper > div {
    position: absolute;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  .inputTextUpperCase > input {
    text-transform: uppercase;
  }

  /* .MuiInputBase-root {
    color: ${({ blockShouldBeDisabled, defValues }) =>
    blockShouldBeDisabled
      ? `${defValues?.defaultDisabledColor} !important`
      : null};
  } */

  .field #label-field {
    color: ${({ blockShouldBeDisabled, defValues }) =>
      blockShouldBeDisabled
        ? `${defValues?.defaultDisabledColor} !important`
        : `${defValues?.labelTextColor} !important`};
  }
`;

const StyledBlockV2 = styled.div`
  /* background: ${({ themeType }) =>
    themeType === "dark" ? FORM_BACKGROUND : "#fff"}; */
  border-radius: ${`${BORDER_RADIUS_BLOCKS}px`};
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.07);
  //margin-bottom: 24px;
  overflow: hidden;
  border: ${({ themeType, isListBlock }) =>
    !isListBlock
      ? "none"
      : themeType === "dark"
      ? `2px solid ${MAIN_COLOR}`
      : "2px solid #e0e4ea"};
  transition: box-shadow 0.2s;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ isListBlock }) => (!isListBlock ? "2px" : "0px")};

  /* &:hover {
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.12);
    border-color: #b3b8c5;
  } */

  .block-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${({ themeType }) =>
      themeType === "dark" ? BLOCKS_HEADER_BG : BLOCKS_HEADER_BG_LIGHT};
    border-radius: ${`${BORDER_RADIUS_BLOCKS}px`};
    padding: 16px 20px;
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
    color: ${({ themeType }) =>
      themeType === "dark" ? TEXT_PRIMARY : "#2d3748"};
    border-bottom: 1px solid #e0e4ea;
    user-select: none;
    border-radius: ${`${BORDER_RADIUS_BLOCKS}px`};
    border: 2px solid #e0e4ea;
  }

  .block-header-list {
    border-bottom: none;
    padding: 8px 0px 0px 8px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    border: none;
  }

  .block-content {
    transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s,
      padding 0.3s;
    overflow: hidden;
    opacity: 1;
    max-height: 2000px;
    background: ${({ themeType }) =>
      themeType === "dark" ? FORM_BACKGROUND : "#fff"};
    will-change: max-height, opacity, padding;
    height: 100%;
    border: 2px solid #e0e4ea;
    border-radius: ${`${BORDER_RADIUS_BLOCKS}px`};
    overflow-y: auto;
  }

  .block-content-list {
    border: none;
  }

  .block-content.collapsed {
    opacity: 0;
    max-height: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 20px;
    padding-right: 20px;
    pointer-events: none;
  }

  // FORM STUFF

  fieldset {
    border: none;
    margin: 0;
    padding: 12px;
    height: min-content;
    background: inherit;
    pointer-events: ${({ blockShouldBeDisabled }) =>
      blockShouldBeDisabled ? "none" : "auto"};
  }

  /* TO QUIT INNER LEGENDS */
  fieldset legend {
    display: none;
  }

  /* TO HIDE RJSF OWN LABEL, AND ONLY SHOW OUR CUSTOM LABELS*/
  .control-label {
    display: none;
  }

  fieldset .field-object:not(:has(fieldset#root_audit)) {
    display: none;
  }

  fieldset .field-object fieldset#root_audit {
    padding: 0px;
  }
`;

const GUIDES_ENABLED_BY_ENV = process.env.REACT_APP_SHOW_GUIDES === "y";
const FEATURE_DEV_DIALOG_ENABLED = false;

export default function SimpleBlock(props) {
  // console.clear();
  // console.log({ props });
  const {
    pre,
    children,
    hasLegend,
    wizardConfig,
    shadowStatus,
    id: blockId,
    formSchema,
    selectedTab,
    moveToAnotherSectionByIndex,
    formInstanceId,
    isListBlock,
    operation,
    stylesVersion,
    //schema,
    collapsed,
    //onCollapseToggle,
    blockTitle,
  } = props;

  const isStylesVersion = stylesVersion === FORM_STYLES_V2;

  const blockIsDisabledByForm = pre?.enabled === false;

  const { theme } = useContext(ThemeContext);
  const muiTheme = useTheme();

  const {
    isWizardEnabled,
    blockShouldBeFocused,
    blockShouldBeDisabled,
    blockWasCompletedBefore,
    blockWizardStep,
    blockIsIncludedInWizardSteps,
    isBlockDisabledByProperty,
    currentStepColor,
    blockListShouldBeBordered,
    listBlocksInWizard,
    blockHasAtLeastSomethingEnabledAndVisible,
  } = useWizard({
    wizardConfig,
    shadowStatus,
    blockId,
    formSchema,
    selectedTab,
    moveToAnotherSectionByIndex,
    formInstanceId,
    isListBlock,
    blockIsDisabledByForm,
    operation,
  });

  const simpleBlockShouldBeBorderFocused =
    blockShouldBeFocused || (isListBlock === true && blockListShouldBeBordered);

  const mainColor = muiTheme?.palette?.content?.titleTextColor;
  const borderBlockColor = simpleBlockShouldBeBorderFocused
    ? currentStepColor
    : muiTheme?.palette?.form?.borderBlock;
  const borderBlockWidth = simpleBlockShouldBeBorderFocused ? "3px" : null;
  const blockBackground = muiTheme?.palette?.form?.bgBlock;

  const blockShouldBeDisabledCalculated =
    blockShouldBeDisabled ||
    isBlockDisabledByProperty ||
    (isListBlock === true &&
      includes(listBlocksInWizard, blockId) &&
      simpleBlockShouldBeBorderFocused === false);

  const BlockComponent = isStylesVersion ? StyledBlockV2 : StyledBlock;

  return (
    <BlockComponent
      pre={pre}
      themeType={theme}
      defValues={{
        mainColor,
        borderBlockColor,
        borderBlockWidth,
        blockBackground,
        defaultDisabledColor: muiTheme.palette.text.disabled,
        labelTextColor: `${muiTheme.palette.form.labelTextColor}BB`,
      }}
      hasLegend={hasLegend}
      blockShouldBeDisabled={blockShouldBeDisabledCalculated}
      blockShouldBeFocused={simpleBlockShouldBeBorderFocused}
      tabIndex={blockShouldBeDisabledCalculated ? -1 : undefined}
      isListBlock={isListBlock}
    >
      {isStylesVersion && (
        <div
          className={`block-header ${isListBlock ? "block-header-list" : ""}`}
          //onClick={() => onCollapseToggle((c) => !c)}
        >
          {blockTitle || "Bloque"}
          {/*collapsed ? (
            <Icon className="fas fa-chevron-down" />
          ) : (
            <Icon className="fas fa-chevron-up" />
          )*/}
          {GUIDES_ENABLED_BY_ENV && FEATURE_DEV_DIALOG_ENABLED ? (
            <Hidden mdDown>
              <ConstructorBlockDialog
                blockId={blockId}
                blockTitle={blockTitle}
              />
            </Hidden>
          ) : null}
        </div>
      )}

      {isStylesVersion ? (
        <div
          className={`block-content${collapsed ? " collapsed" : ""} ${
            isListBlock ? "block-content-list" : ""
          }`}
        >
          <StatusWizardIndicator
            blockIsIncludedInWizardSteps={blockIsIncludedInWizardSteps}
            isWizardEnabled={isWizardEnabled}
            blockWizardStep={blockWizardStep}
            blockShouldBeDisabled={blockShouldBeDisabled}
            blockWasCompletedBefore={blockWasCompletedBefore}
            blockShouldBeFocused={blockShouldBeFocused}
            blockId={blockId}
            blockIsDisabledByForm={blockIsDisabledByForm}
            listBlocksInWizard={listBlocksInWizard}
            simpleBlockShouldBeBorderFocused={simpleBlockShouldBeBorderFocused}
            isBlockDisabledByProperty={isBlockDisabledByProperty}
            blockHasAtLeastSomethingEnabledAndVisible={
              blockHasAtLeastSomethingEnabledAndVisible
            }
          />
          {children}
        </div>
      ) : (
        <>
          <StatusWizardIndicator
            blockIsIncludedInWizardSteps={blockIsIncludedInWizardSteps}
            isWizardEnabled={isWizardEnabled}
            blockWizardStep={blockWizardStep}
            blockShouldBeDisabled={blockShouldBeDisabled}
            blockWasCompletedBefore={blockWasCompletedBefore}
            blockShouldBeFocused={blockShouldBeFocused}
            blockId={blockId}
            blockIsDisabledByForm={blockIsDisabledByForm}
            listBlocksInWizard={listBlocksInWizard}
            simpleBlockShouldBeBorderFocused={simpleBlockShouldBeBorderFocused}
            isBlockDisabledByProperty={isBlockDisabledByProperty}
            blockHasAtLeastSomethingEnabledAndVisible={
              blockHasAtLeastSomethingEnabledAndVisible
            }
          />
          {children}
        </>
      )}
    </BlockComponent>
  );
}
